/** Parent identity is distinct from calendar projection: a travel reservation
 * may occupy the whole day without becoming an Event container. Operational
 * lifecycle and ownership are enforced by the canonical meetings reader. */
export type MeetingParentEvent = {
  id: number;
  meetingType?: string | null;
  inviteSource?: string | null;
  startTime?: string | Date | null;
  endTime?: string | Date | null;
};

export function isMeetingParentEventCandidate(event: MeetingParentEvent): boolean {
  return Number.isSafeInteger(Number(event.id)) && Number(event.id) > 0
    && event.meetingType === 'Evento'
    && event.inviteSource !== 'travel_email';
}

/** Date suggestions are optional; the user can always choose another Event.
 * End boundaries are exclusive, so a check-out at midnight covers no part
 * of the following day. The form's civil date uses its existing local zone. */
export function meetingEventOverlapsLocalDate(event: MeetingParentEvent, date: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !event.startTime || !event.endTime) return false;
  const start = new Date(event.startTime).getTime();
  const end = new Date(event.endTime).getTime();
  const day = new Date(`${date}T00:00:00`);
  const nextDay = new Date(day);
  nextDay.setDate(nextDay.getDate() + 1);
  return Number.isFinite(start) && Number.isFinite(end) && end > start
    && start < nextDay.getTime() && end > day.getTime();
}
